<section class="fullHeight flex sec bg">
    <div class="pad  fullWidth">
        <div class="flex pad">
            <div style="flex: 1;">
                <h1 class="text fs">
                    <i class=" fs">Your Trusted</i>
                </h1>
                <h1 class="text" style="color: var(--primary-color);"><i class=" fs">Travel Insurance Partner</i></h1>
                <br><br><br>
                <div class="flex btnCar">
                    <!-- <a routerLink="/signin"> -->
                    <button (click)="goto('signin')" class="btns block">
                        <span>Sign In</span>
                    </button>
                    <!-- </a> -->

                    <!-- <a routerLink="/signin"> -->

                    <button (click)="goto('signup')" class="btns outline">
                        <span>
                            Sign Up
                        </span>
                    </button>
                    <!-- </a> -->
                </div>
            </div>
            <div style="flex: 1;">
                <figure class="bg bGbdrRad" id="banner">

                </figure>
            </div>
        </div>
    </div>
</section>